import { getAmplitudeInstance } from '../amplitudeHelpers';

type logTrailPageViewLimitReachedParams = {
  limit: number;
  trail_id: number;
};

/**
 * A logged out user on web is redirected to a sign-up page after hitting the logged-out trail limit.
 * @param params - Attributes to log with the amplitude event
 * @param params.limit - The number of trails users are limited to viewing before displaying a sign-up wall.
 * @param params.trail_id - the trail id of the trail page
 */
const logTrailPageViewLimitReached = ({ limit, trail_id }: logTrailPageViewLimitReachedParams, callback?: () => void) => {
  getAmplitudeInstance().logEvent('trail page view limit reached', { limit, 'trail id': trail_id }, callback);
};

export default logTrailPageViewLimitReached;
